

















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class QuestionList extends Vue {
  @Prop({ type: Array, default: () => [] })
  questions!: any[];

  @Prop({ type: String, default: 'q' })
  keyPrefix!: string;

  @Prop({ type: String, default: '' })
  regeneratingId!: string;

  isRegenerating(q: any): boolean {
    return !!this.regeneratingId && this.regeneratingId === (q && q.id);
  }
}
